import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import UserOrders from './pages/UserOrders';
import AdminPanel from './pages/AdminPanel';
import ProductManagement from './pages/ProductManagement';
import OptionManagement from './pages/OptionManagement';
import UserManagement from './pages/UserManagement';
import OrderManagement from './pages/OrderManagement';
import OrderDetail from './pages/OrderDetail';
import Statistics from './pages/Statistics';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <NotificationProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/siparislerim" element={<UserOrders />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/admin/products" element={<ProductManagement />} />
              <Route path="/admin/options" element={<OptionManagement />} />
              <Route path="/admin/users" element={<UserManagement />} />
              <Route path="/admin/orders" element={<OrderManagement />} />
              <Route path="/admin/orders/:id" element={<OrderDetail />} />
              <Route path="/admin/statistics" element={<Statistics />} />
            </Routes>
          </Router>
        </NotificationProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
